/**
 * Route for `eu-us-data-privacy-framework-registration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EuUsDataPrivacyFrameworkRegistrationPage } from "../features/eu-us-data-privacy-framework-registration/EuUsDataPrivacyFrameworkRegistrationPage";

export const euUsDataPrivacyFrameworkRegistrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/eu-us-data-privacy-framework-registration",
	component: EuUsDataPrivacyFrameworkRegistrationPage,
});

export default euUsDataPrivacyFrameworkRegistrationRoute;
